import axios from "../axios";

const PCC_URL = "/api/pcc";

export function refreshPCCActivations() {
  return axios({
    url: `${PCC_URL}/refresh-activations`,
    method: "get",
  });
}

export function fetchOrganizations() {
  return axios({
    url: `${PCC_URL}/orgs`,
    method: "get",
  });
}

export function uploadContractDocument(id: string, formData: FormData) {
  return axios({
    url: `${PCC_URL}/${id}`,
    method: "put",
    data: formData,
  });
}
